import React from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import _ from "lodash";
import LottieLoader from "../LottieLoader";
import lottieLoaderFile from "../../files/animation/loading.json";
import lottieEmptyFile from "../../files/animation/empty_new.json";
import paginationFactory from "react-bootstrap-table2-paginator";
import userImage from "../../files/user.png";
import Link from "components/ExtendLink";
import { Row, Card, CardBody, CardHeader, Col } from "reactstrap";
import { getFileIconClass } from "../../constants/general.constant";

function EducationPatientList(props) {
    const { data = [], limit = 0, page = 0, totalPages = 0, totalCount = 0 } = props.educationMaterialPatients

    function fullname(cell, row) {
        const profile = row.profileImage ? process.env.REACT_APP_VIDEO_CALL_REQUEST + "/" + row.profileImage : userImage;
        // return <UserName user={row} />;
        return (
            <div className={row.isActive ? "" : " text-danger"}>
                <span>
                    <img src={profile} className="mr-2" alt="image"
                        onError={({ currentTarget }) => {
                            currentTarget.onerror = null; // prevents looping
                            currentTarget.src = userImage;
                        }} />
                    {capitalize(row.lname)}
                    {", "}
                    {capitalize(row.fname)}
                </span>
            </div>
        );
    }
    function capitalize(cell) {
        if (cell) {
            return cell.charAt(0).toUpperCase() + cell.slice(1);
        }
    }
    const customTotal = (from, to, size) => (
        <span className="react-bootstrap-table-pagination-total">
            {"   "}Showing {from} to {to} of {size} Results
        </span>
    );
    const options = {
        page: parseInt(page || 0),
        sizePerPage: parseInt(limit || 0),
        totalSize: parseInt(totalCount || 0),
        firstPageText: "First",
        prePageText: "Back",
        nextPageText: "Next",
        lastPageText: "Last",
        nextPageTitle: "First page",
        prePageTitle: "Pre page",
        firstPageTitle: "Next page",
        lastPageTitle: "Last page",
        hideSizePerPage: parseInt(totalCount) == 0 ? true : false, // Hide the sizePerPage dropdown always
        hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
        showTotal: parseInt(totalCount) == 0 ? false : true,
        paginationTotalRenderer: customTotal,
        sizePerPageList: [
            {
                text: "25",
                value: 25,
            },
            {
                text: "50",
                value: 50,
            },
            {
                text: "100",
                value: 100,
            },
            {
                text: "200",
                value: 200,
            },
        ], // A numeric array is also available. the purpose of above example is custom the text
    };

    return (
        <div>
            <BootstrapTable
                remote={{
                    sort: false,
                    pagination: true,
                    filter: true,
                    search: true,
                }}
                wrapperClasses="table-responsive"
                keyField="_id"
                noDataIndication={() => {
                    return (
                        <div>
                            {props.loading && (
                                <LottieLoader
                                    loadLoop={true}
                                    autoplayLoop={true}
                                    source={lottieLoaderFile}
                                    Lheight={150}
                                    Lwidth={150}
                                    subTitle={"Please Wait ..."}
                                />
                            )}
                            {!props.loading && (
                                <LottieLoader
                                    loadLoop={true}
                                    autoplayLoop={true}
                                    source={lottieEmptyFile}
                                    Lheight={300}
                                    Lwidth={300}
                                    title={"Sorry! No data found"}
                                    subTitle={"We can't find any educational material sent patients."}
                                />
                            )}
                        </div>
                    );
                }}
                data={props.loading ? [] : data}
                columns={[
                    {
                        dataField: "lastNameFull",
                        text: "Last, First Name",
                        sort: true,
                        formatter: fullname,
                    },
                    {
                        dataField: "bday",
                        text: "DOB",
                        formatter: (cell, row) => {
                            return moment(row.bday).format("MMMM DD, YYYY");
                        },
                        sort: true
                    },
                    {
                        dataField: "createdAt",
                        text: "Enrolled Date",
                        sort: true,
                        formatter: (cell) => (
                            <p>
                                {cell ? moment(cell).format("MMMM DD, YYYY hh:mm:ss A") : "-"}
                            </p>
                        ),
                    },
                    {
                        dataField: "educationMaterialLastNote",
                        text: "Date of Last Educational Material Note",
                        sort: true,
                        formatter: (cell) => (
                            <p>
                                {cell ? moment(cell.createdAt).format("MMMM DD, YYYY hh:mm:ss A") : "-"}
                            </p>
                        ),
                    },
                    {
                        dataField: "organization",
                        text: "Organization",
                        sort: true,
                        formatter: (cell) => (
                            <p>
                                {cell ? cell : "-"}
                            </p>
                        ),
                    },
                    {
                        dataField: "mainCareProviderFName",
                        text: "Main Care Provider",
                        sort: true,
                        formatter: (cell) => (
                            <p>
                                {cell ? cell : "-"}
                            </p>
                        ),
                    },
                    {
                        dataField: "test",
                        text: "More Details",
                        sort: false,
                        headerStyle: (colum, colIndex) => {
                            return { width: "6%", textAlign: "left" };
                        },
                        formatter: (cell, row, rowIndex) => {
                            return (
                                <Link
                                    to={`/dashboard/${row.fname
                                        .replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '')
                                        .toLowerCase()}-${row.lname.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9 ]/g, '').toLowerCase()}/${row._id
                                        }`}
                                    className="btn pull-right more-btn "
                                >
                                    <i class="mdi mdi-account-card-details"></i> More Details
                                </Link>
                            );
                        },
                    },
                ]}
                pagination={options.page > 0 ? paginationFactory(options) : undefined}
                bordered
                onTableChange={props.pagination}
                expandRow={{
                    renderer: (row) =>
                        rowComponent(row, props),
                    onlyOneExpanding: false,
                    showExpandColumn: true,
                    expandByColumnOnly: false
                }}
            ></BootstrapTable>
        </div>
    );
}
function capitalize(cell) {
    if (cell) {
        return cell.charAt(0).toUpperCase() + cell.slice(1);
    }
}
const rowComponent = (row, props) => {
    if (row) {
        let readingsHeader = "Did not send any educational documnet to this patient";
        if (_.size(row.educationMaterialLogs) > 0) {
            readingsHeader = 'Educational Material History'
        }
        return (
            <div>
                <Row style={{ margin: "15px 0px" }}>
                    <Col sm="12" className="mt-2 remove-summary-paddding">
                        <Card style={{ border: "0px 10px 10px 0px" }}>
                            <CardHeader className="text-center summary-title summary-header">
                                {capitalize(row?.lname || '')} {capitalize(row?.fname || '')} - {readingsHeader}
                            </CardHeader>
                            {row && row.educationMaterialLogs && row.educationMaterialLogs.length > 0 && (
                                <CardBody className='padding-card-body'>
                                    <BootstrapTable
                                        keyField='_id'
                                        data={row.educationMaterialLogs}
                                        columns={[
                                            {
                                                dataField: 'educationMaterialType',
                                                text: 'Educational Material Type',
                                                formatter: (cell, row) => {
                                                    if (cell) {
                                                        const dataString = cell && cell.materialType ? cell.materialType : '-'
                                                        return (
                                                            <div >
                                                                <p>{dataString}</p>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (<div> "-" </div>)
                                                    }
                                                },
                                                headerStyle: (colum, colIndex) => {
                                                    return { width: '20%', textAlign: 'left' };
                                                },
                                                sort: false
                                            },
                                            {
                                                dataField: 'sender',
                                                text: 'Send By',
                                                formatter: (cell, row) => {
                                                    const user = cell;
                                                    const profile = user.profileImage || userImage;
                                                    return (
                                                        <div className={user.isActive ? "" : " text-danger"}>
                                                            <p>
                                                                <img src={profile} className="mr-2" alt="image"
                                                                    onError={({ currentTarget }) => {
                                                                        currentTarget.onerror = null; // prevents looping
                                                                        currentTarget.src = userImage;
                                                                    }} />
                                                                {capitalize(user.lname)}
                                                                {", "}
                                                                {capitalize(user.fname)}
                                                            </p>
                                                        </div>
                                                    )
                                                },
                                                headerStyle: (colum, colIndex) => {
                                                    return { width: '15%', textAlign: 'left' };
                                                },
                                                sort: false
                                            },
                                            {
                                                dataField: 'createdAt',
                                                text: 'Material Send Date',
                                                formatter: (cell, row) => {
                                                    if (cell) {
                                                        return (
                                                            <div >
                                                                <p>{moment(cell).format("MMMM DD, YYYY hh:mm A")}</p>
                                                            </div>
                                                        )
                                                    } else {
                                                        return (<div> - </div>)
                                                    }
                                                },
                                                headerStyle: (colum, colIndex) => {
                                                    return { width: '15%', textAlign: 'left' };
                                                },
                                                sort: false
                                            },
                                            {
                                                dataField: 'files',
                                                text: 'Educational Material Documents/Link',
                                                formatter: (cell, row) => {
                                                    if (cell || row) {
                                                        return (
                                                            <>
                                                                {cell && (
                                                                    <div>
                                                                        <h5>Educational Documents</h5>
                                                                        {cell.map((item, index) => {
                                                                            const { icon, color } = getFileIconClass(item.name);
                                                                            return (
                                                                                <div key={index} className="link-hover">
                                                                                    <a
                                                                                        href={`${process.env.REACT_APP_VIDEO_CALL_REQUEST}/${item.path}`}
                                                                                        target="_blank"
                                                                                        rel="noopener noreferrer"
                                                                                        style={{ textDecoration: "none" }}
                                                                                    >
                                                                                        <p style={{ display: "flex", alignItems: "center" }}>
                                                                                            <i
                                                                                                className={icon}
                                                                                                style={{ fontSize: 20, color, marginRight: 6 }}
                                                                                            ></i>
                                                                                            <span
                                                                                                style={{
                                                                                                    color: "#000000",
                                                                                                    textDecoration: "underline",
                                                                                                    fontWeight: 200,
                                                                                                    display: "inline-block",
                                                                                                    maxWidth: "350px",
                                                                                                    whiteSpace: "nowrap",
                                                                                                    overflow: "hidden",
                                                                                                    textOverflow: "ellipsis",
                                                                                                }}
                                                                                                title={item.name}
                                                                                            >
                                                                                                {item.name}
                                                                                            </span>
                                                                                        </p>
                                                                                    </a>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                )}

                                                                {row.materialLink && row.materialLink.length > 0 && (
                                                                    <div>
                                                                        <h5>Educational Material Link</h5>
                                                                        {row.materialLink.map((item, index) => (
                                                                            <div key={index} className="link-hover">
                                                                                <a
                                                                                    href={item}
                                                                                    target="_blank"
                                                                                    rel="noopener noreferrer"
                                                                                    style={{ textDecoration: "none" }}
                                                                                >
                                                                                    <p style={{ display: "flex", alignItems: "center" }}>
                                                                                        <i
                                                                                            className="mdi mdi-link mr-2"
                                                                                            style={{ fontSize: 20, color: "blue", marginRight: 6 }}
                                                                                        ></i>
                                                                                        <span
                                                                                            style={{
                                                                                                color: "#000000",
                                                                                                textDecoration: "underline",
                                                                                                fontWeight: 200,
                                                                                                display: "inline-block",
                                                                                                maxWidth: "350px",
                                                                                                whiteSpace: "nowrap",
                                                                                                overflow: "hidden",
                                                                                                textOverflow: "ellipsis",
                                                                                            }}
                                                                                            title={item}
                                                                                        >
                                                                                            {item}
                                                                                        </span>
                                                                                    </p>
                                                                                </a>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                            </>
                                                        );
                                                    } else {
                                                        return "-";
                                                    }
                                                },
                                                headerStyle: (colum, colIndex) => {
                                                    return { width: '25%', textAlign: 'left' };
                                                },
                                                sort: false
                                            },
                                            {
                                                dataField: "message",
                                                text: "Message",
                                                formatter: (cell) => <p>{cell ? cell : "-"}</p>,
                                            },
                                        ]}
                                    />
                                </CardBody>
                            )}
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
};
export default EducationPatientList;
